import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dog-icon',
  templateUrl: './dog-icon.component.html',
  styleUrls: ['./dog-icon.component.scss']
})
export class DogIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
